import { useEffect, useState } from 'react';
import { unhandledEnumCase } from 'rpc-client-utils';

import { InAppEvaluationRequest } from '../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsEvaluationService';
import { PurchaseMotion } from '../types/PurchaseMotion';
import { fetchPurchaseMotions } from '../utils/fetchPurchaseMotions';

export const usePurchaseMotions = ({
  location,
  apiName,
}: {
  location: NonNullable<InAppEvaluationRequest['locations']>[number];
  apiName: NonNullable<InAppEvaluationRequest['productApiNames']>[number];
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error>();
  const [purchaseMotions, setPurchaseMotions] = useState<
    Exclude<PurchaseMotion, unhandledEnumCase>[]
  >([]);

  useEffect(() => {
    let isMounted = true;
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setLoading(true);
    setError(undefined);
    setPurchaseMotions([]);
    fetchPurchaseMotions({ location, apiName })
      .then((motions) => {
        if (!isMounted) return;
        setPurchaseMotions(motions);
      })
      .catch((e) => {
        if (!isMounted) return;
        const errorObj = e instanceof Error ? e : new Error(String(e));
        setError(errorObj);
      })
      .finally(() => {
        if (!isMounted) return;
        setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [location, apiName]);

  return {
    loading,
    error,
    purchaseMotions,
  };
};
